// src/resources/rdf/ValidateButton.js
import * as React from "react";
import { useRecordContext } from "react-admin";
import { Button, Box, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import CheckIcon from "@mui/icons-material/Check";
import { adminPatch } from "../../config/api";
import useModerationAction from "../../hooks/useModerationAction";

export default function ValidateButton() {
    const record = useRecordContext();
    const { loading, run } = useModerationAction();

    if (!record || record.status === "VALIDATED") return null;

    const onClick = async (event) => {
        event?.stopPropagation?.();
        await run({
            id: record.id,
            request: () => adminPatch(`/rdf/${record.id}/validate`),
            successMessage: "RDF validé",
        });
    };

    return (
        <Tooltip title="Valider ce RDF">
            {/* wrapper pour garder le tooltip quand le bouton est disabled */}
            <span>
        <Button
            onClick={onClick}
            disabled={loading}
            variant="contained"
            aria-label="Valider ce RDF"
            sx={{
                bgcolor: "black",
                color: "white",
                borderRadius: "20px",
                textTransform: "none",
                px: 2,
                py: 0.5,
                fontWeight: "bold",
                ml: 1,
                "&:hover": { bgcolor: "#333" },
            }}
            startIcon={
                loading ? <CircularProgress size={16} sx={{ color: "white" }} /> : null
            }
        >
          Valider
          <Box
              sx={{
                  ml: 1,
                  bgcolor: "white",
                  color: "black",
                  borderRadius: "50%",
                  width: 20,
                  height: 20,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  border: "1px solid black",
              }}
          >
            <CheckIcon sx={{ fontSize: 14 }} />
          </Box>
        </Button>
      </span>
        </Tooltip>
    );
}
